import styles from "./ViewHotspotVideo.module.css";
import { MdPlayCircleFilled, MdCancel } from "react-icons/md";
import { useAppStore } from "../../../hooks/store/useAppStore";
import { currentHotspotSelector } from "../../../hooks/store/getters";
import { useState } from 'react';
import { setHotspotPauseAudioSelector } from "../../../hooks/store/setters";
import { useEffect } from 'react';

const ViewHotspotVideo = () => {
    
    const [showVideo, setShowVideo] = useState(false);
    const [hidePlayBtn, setHidePlayBtn] = useState(false);
    const currentHotspot = useAppStore(currentHotspotSelector);
    const setHotspotPauseaudio = useAppStore(setHotspotPauseAudioSelector);
    
    const { image, video } = currentHotspot;
    
    useEffect(() => {
        
        if (!image || !image.url) {
            console.log('show default play video');
            setHidePlayBtn(true)
            setShowVideo(true);
            setHotspotPauseaudio(true);
        }
        
    }, [image, setShowVideo, setHotspotPauseaudio])
    
    const openVideo = () => {
        console.log('in play video');
        setShowVideo(true);
        setHotspotPauseaudio(true);
    }
    const hideVideo = () => {
        setShowVideo(false);
        setHotspotPauseaudio(false);
    };

    if (!video.url) return null;
    
    return (
        <div className={styles.hotspotVideo}>
            {
                (video.file || video.url) && !hidePlayBtn && (
                    <span className={styles.icon}>
                        <MdPlayCircleFilled
                            className="text-warning"
                            onClick={openVideo}
                        />
                    </span>
                )
            }
            {
                showVideo && (
                    <div className={`${styles.hotspotVideoPlayer} ${hidePlayBtn ? styles.hotspoVideoPlayerRelative: ''}`}>
                        {!hidePlayBtn && <div className={styles.videoCloseBtn} onClick={hideVideo}>
                            <MdCancel />
                        </div>}
                        <video
                            src={video.url || video.file}
                            controls
                            autoPlay={true}
                        ></video>
                    </div>
                )
            }
        </div>
    );
};

export default ViewHotspotVideo;